import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

/** @format */

/**
 * External dependencies
 */
import { axisLeft as d3AxisLeft } from 'd3-axis';

var calculateYGridValues = function calculateYGridValues(numberOfTicks, limit, roundValues) {
  var grids = [];

  for (var i = 0; i < numberOfTicks; i++) {
    var val = (i + 1) / numberOfTicks * limit;
    var rVal = roundValues ? Math.round(val) : val;

    if (grids[grids.length - 1] !== rVal) {
      grids.push(rVal);
    }
  }

  return grids;
};

var getNegativeYGrids = function getNegativeYGrids(yMin, step) {
  if (yMin >= 0) {
    return [];
  }

  var numberOfTicks = Math.ceil(-yMin / step);
  return calculateYGridValues(numberOfTicks, yMin, yMin < -1);
};

var getPositiveYGrids = function getPositiveYGrids(yMax, step) {
  if (yMax <= 0) {
    return [];
  }

  var numberOfTicks = Math.ceil(yMax / step);
  return calculateYGridValues(numberOfTicks, yMax, yMax > 1);
};

export var getYGrids = function getYGrids(yMin, yMax, step) {
  return [0].concat(_toConsumableArray(getNegativeYGrids(yMin, step)), _toConsumableArray(getPositiveYGrids(yMax, step)));
};
export var drawYAxis = function drawYAxis(node, scales, formats, margin, isRTL) {
  var yGrids = getYGrids(scales.yScale.domain()[0], scales.yScale.domain()[1], scales.step);
  var width = scales.xScale.range()[1];
  var xPosition = isRTL ? width + margin.left + margin.right / 2 - 15 : -margin.left / 2 - 15;
  var withPositiveValuesClass = scales.yMin >= 0 || scales.yMax > 0 ? ' with-positive-ticks' : '';
  node.append('g').attr('class', 'grid' + withPositiveValuesClass).attr('transform', "translate(-".concat(margin.left, ", 0)")).call(d3AxisLeft(scales.yScale).tickValues(yGrids).tickSize(-width - margin.left - margin.right).tickFormat(''));
  node.append('g').attr('class', 'axis y-axis').attr('aria-hidden', 'true').attr('transform', 'translate(' + xPosition + ', 12)').attr('text-anchor', 'start').call(d3AxisLeft(scales.yScale).tickValues(scales.yMax === 0 && scales.yMin === 0 ? [yGrids[0]] : yGrids).tickFormat(function (d) {
    if (d > -1 && d < 1 && formats.yBelow1Format) {
      return formats.yBelow1Format(d);
    }

    return formats.yFormat(d);
  }));
};
//# sourceMappingURL=axis-y.js.map